import { Button } from 'primereact/components/button/Button';
import React, { FC, memo, useCallback, useState } from 'react';
import { filterDateStringsKeys } from 'state/ducks/filter-date-search/types';
import { localized } from 'state/i18n';
import { UploadServiceHistoryDialog } from 'view/shared/components/upload-service-history/upload-service-history-dialog';
import FilterDateBar from '../filter-date-bar';
import './filter-date-bar-service-history.scss';

interface Props {
	unitId: number | undefined;
	idOfFilterDateBarParent: filterDateStringsKeys;
	handleFilterByDates: (startDate?: Date, endDate?: Date) => Promise<void>;
	minStartDate?: Date;
	initialStartDate?: Date;
	initialEndDate?: Date;
	className?: string;
	canUpload: boolean;
}
export const FilterDateBarServiceHistory: FC<Props> = memo(
	({ unitId, idOfFilterDateBarParent, handleFilterByDates, initialStartDate, initialEndDate, canUpload }) => {
		const [showUploadDialog, setShowUploadDialog] = useState(false);

		const showDialog = useCallback(() => {
			setShowUploadDialog(true);
		}, []);

		const hideDialog = useCallback(() => {
			setShowUploadDialog(false);
		}, []);

		return (
			<div className="row-space-between">
				<FilterDateBar
					idOfFilterDateBarParent={idOfFilterDateBarParent}
					handleFilterByDates={handleFilterByDates}
					initialStartDate={initialStartDate}
					initialEndDate={initialEndDate}
				/>
				{canUpload && (
					<div className="action-button-container">
						<Button
							className="p-button-background-color-org-grey"
							label={localized('UploadDocument')}
							onClick={showDialog}
						/>
					</div>
				)}
				{canUpload && (
					<UploadServiceHistoryDialog
						unitId={unitId}
						visible={showUploadDialog}
						onSave={hideDialog}
						onCancel={hideDialog}
					/>
				)}
			</div>
		);
	}
);
